module.exports = __webpack_public_path__ + "img/leftside_300.bb1de21b.png";